






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import axios from 'axios';
import EventBus from '@/eventBus';
import JSConfetti from 'js-confetti';
import isURL from 'validator/lib/isURL';
// eslint-disable-next-line import/no-extraneous-dependencies
import i18n from 'vue-i18n';
import { get, upperFirst, toLower, map, uniqBy, uniq, remove, add, cloneDeep } from 'lodash';
import { User } from '@/types/GlobalTypes.ts';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';
import CoPeople from '@/components/Molecules/co-people/CoPeople.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import { SUPPORTED_IMAGE_ACCEPT } from '@/constants/fileUpload';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';
import CoShare from '@/components/Organisms/co-share/CoShare.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoImage from '@/components/Atoms/co-image/CoImage.vue';
import CoDragDropFileUpload from '@/components/Organisms/co-drag-drop-file-upload/CoDragDropFileUpload.vue';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoBadge from '@/components/Atoms/co-badge/CoBadge.vue';
import CoTag from '@/components/Atoms/co-tag/CoTag.vue';
import CoContentSection from '@/components/Organisms/сo-content-section/CoContentSection.vue';
import { createAudioSection, getSectionKey } from '@/components/Organisms/сo-content-section/models';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoLockedContent from '@/components/Molecules/co-locked-content/CoLockedContent.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoPostEditor from '@/components/Organisms/co-post-editor/coPostEditor.vue';
import CoPost from '@/components/Organisms/co-post/CoPost.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoAcceptReject from '@/components/Molecules/co-accept-reject/CoAcceptReject.vue';
import CoMatch from '@/components/Molecules/co-match/CoMatch.vue';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoCardPlan from '@/components/Molecules/co-card-plan/CoCardPlan.vue';
import CoFile from '@/components/Organisms/CoFile/CoFile.vue';
import CoStreamUpdatesIndicator from '@/components/Organisms/co-stream-updates-indicator/CoStreamUpdatesIndicator.vue';
import { AttachmentFile, normalizeAttachmentFile } from '@/utils/attachment';

import { UserFilterOption } from '@/components/Organisms/co-user-filter/models';

const jsConfetti = new JSConfetti();
const PAGE_VISIBILITY = Object.freeze({
    PRIVATE: 'private',
    COMMUNITY: 'community',
    PAID: 'paid',
});

export default {
    name: 'ViewPage',
    components: {
        CoFormGroup,
        CoCheckbox,
        CoInput,
        CoPostEditor,
        CoBadge,
        CoConfirmation,
        CoText,
        CoRoundButton,
        CoButton,
        CoIcon,
        CoHeadline,
        CoSkeleton,
        CoPeople,
        CoCard,
        CoLink,
        CoPill,
        CoShare,
        CoImage,
        CoDragDropFileUpload,
        CoLoadingIndicator,
        CoTippy,
        CoTag,
        CoContentSection,
        CoDropdown,
        CoDropdownItem,
        CoLockedContent,
        CoModal,
        CoPost,
        CoAcceptReject,
        CoMatch,
        CoUser,
        CoCardPlan,
        CoFile,
        CoStreamUpdatesIndicator,
    },
    i18n: {
        messages: {
            en: {
                addmember: 'Add member',
                requestsent: 'Request sent',
                media: 'Media',
                unfollowpage: 'Do you want to unfollow this page?',
                posts: 'Posts',
                joinRequestSent: 'Join request sent',
                joinedPageAsContributor: 'You have joined this page as a contributor',
                aboutthepage: 'About the page',
                contributersexpl: 'Contributors can only create updates',
                nofollowers: 'No followers yet. Be the first one.',
                ownersexpl: 'Owners can add/remove owners and contributors, and create updates',
                ownerishidden: "Owner's profile is hidden",
                unpublishedAdmin: 'Only admins and page members see this.',
                unpublishedDefault: 'Only page members see this.',
                closePreviewAsMember: 'Close Preview',
                previewAsMember: 'Preview as Member',
                privatePageHeadline: 'Private Page',
                communityPageHeadline: 'Community members see this page',
                private: 'Private',
                updatePage: 'Update Page',
                pageVisibility: 'Page Visibility',
                joinrequests: 'These members want to join',
                joinRequestRejected: 'Join request rejected',
                joinRequestAccepted: 'Join request accepted',
                requestToJoinTooltip: 'Request to join this page',
                pageIsInviteOnlyTooltip: 'Page is invite only',
                invalidLink: 'Invalid link',
                attachLink: 'Add a link',
                makeContributor: 'Make @:labels.contributor',
                makeOwner: 'Make @:labels.owner',
                suggestedsizes: 'Suggested size 1280x720px (16:9)',
                leavepage: 'Do you want to leave this page?',
                creatorCanNotLeavePage: 'As the creator of this page, you cannot leave it.',
                joinpermissions: 'How can other members join?',
                joininviteonly: 'By Invitation Only',
                joinapprovalbased: 'Members can request to join',
                joinopen: 'Everyone can join',
                createdthispage: 'created this page',
                unlockPageModalTitle: 'Unlock this page',
                unlockPageModalPlansDescription: 'Choose a plan to unlock this page.',
                unlockPageModalOwnersDescription:
                    'Unfortunately, you cannot unlock this page on your own. Please contact the page owners.',

                visibility: 'Who can see this page?',
                privateinfo: 'Private, only visible to members of this page',
                community: 'Visible to everyone in the community',

                whocanfollow: 'Anyone who can see the page can follow it.',
                rolesexplained1: `Owners can edit and delete the page and can add and remove contributors.`,
                rolesexplained2: `Contributors can publish posts on the page.`,
                rolesexplained3: `Followers receive notifications about every post on the page.`,

                messages: {
                    makeCommunity: 'Page will be visible to community members.',
                },
            },
            de: {
                addmember: 'Mitglied hinzufügen',
                requestsent: 'Anfrage gesendet',
                media: 'Medien',
                unfollowpage: 'Möchtest du dieser Seite nicht mehr folgen?',
                posts: 'Beiträge',
                joinRequestSent: 'Anfrage gesendet',
                joinedPageAsContributor: 'Du bist jetzt Mitwirkende*r dieser Seite',
                aboutthepage: 'Über diese @:labels.page',
                contributersexpl: '@:labels.contributers können nur @:labels.updates erstellen',
                nofollowers: 'Noch keine Follower. Mach den Anfang.',
                ownersexpl:
                    '@:labels.owners können @:labels.owners und @:labels.contributers hinzufügen/entfernen und @:labels.updates erstellen',
                ownerishidden: 'Das Profil des @:labels.owner ist nicht sichtbar.',
                unpublishedAdmin: 'Nur Admins und Seitenmitglieder sehen dies.',
                unpublishedDefault: 'Nur Seitenmitglieder sehen dies.',
                closePreviewAsMember: 'Vorschau schließen',
                previewAsMember: 'Vorschau als Mitglied',
                privatePageHeadline: 'Private Seite',
                communityPageHeadline: 'Community-Mitglieder sehen diese Seite',
                private: 'Privat',
                updatePage: 'Seite bearbeiten',
                pageVisibility: 'Seiten Sichtbarkeit',
                joinrequests: 'Diese Mitglieder möchten beitreten',
                joinRequestRejected: 'Beitrittsanfrage abgelehnt',
                joinRequestAccepted: 'Beitrittsanfrage angenommen',
                requestToJoinTooltip: 'Anfrage, dieser Seite beizutreten',
                pageIsInviteOnlyTooltip: 'Seite ist nur auf Einladung',
                invalidLink: 'Ungültiger Link',
                attachLink: 'Link hinzufügen',
                makeContributor: 'Zu @:labels.contributor machen',
                makeOwner: 'Zu @:labels.owner machen',
                suggestedsizes: 'Empfohlene Größe 1280x720px (16:9)',
                leavepage: 'Möchtest du diese Seite verlassen?',
                creatorCanNotLeavePage: 'Als Ersteller:in dieser Seite kannst du sie nicht verlassen.',
                joinpermissions: 'Wie können andere Mitglieder beitreten?',
                joininviteonly: 'Nur durch Hinzufügen',
                joinapprovalbased: 'Mitglieder können Beitrittsanfragen stellen',
                joinopen: 'Alle können beitreten',
                createdthispage: 'hat diese Seite erstellt',
                unlockPageModalTitle: 'Diese Seite freischalten',
                unlockPageModalPlansDescription: 'Wähle einen Plan aus, um diese Seite freizuschalten.',
                unlockPageModalOwnersDescription:
                    'Leider kannst du diese Seite nicht selbst freischalten. Bitte kontaktiere die Seiteninhaber:innen.',

                visibility: 'Wer kann diese Seite sehen?',
                privateinfo: 'Privat, nur sichtbar für Mitglieder dieser Seite',
                community: 'Sichtbar für alle in der Community',

                whocanfollow: 'Wer die Seite sehen kann, kann ihr folgen.',
                rolesexplained1: `Inhaber:innen können die Seite bearbeiten und löschen und können Mitwirkende hinzufügen und entfernen.`,
                rolesexplained2: `Mitwirkende können Beiträge auf der Seite veröffentlichen.`,
                rolesexplained3: `Follower*innen erhalten Benachrichtigungen über jeden Beitrag auf der Seite.`,

                messages: {
                    makeCommunity: 'Die Seite wird für Community-Mitglieder sichtbar sein.',
                },
            },
        },
    },
    props: {
        pageSlug: {
            type: String,
            required: true,
        },
        me: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            page: {},
            followers: [],
            owners: [],
            channel: {},

            channelList: [],

            loadingMembers: false,
            members: [], // list of members with there roles Owner, Contributor, Follower

            newImage: null,
            newImageUploading: false,
            imageAccept: SUPPORTED_IMAGE_ACCEPT,

            sectionsRerenderKey: 0,

            updates: [],
            updatesBank: [],
            updatesNextPage: null,
            loadingUpdates: false,
            focusPostID: this.getRouteFocusPostID(),

            joinStatus: null,

            membersCandidates: [],

            pendingRequests: [],
            preview: false,

            // join strategy
            inviteOnly: true,
            approvalBased: false,
            open: false,

            links: [],
            newlink: '',

            fetchedUsers: {},
            pendingPageAttachments: [] as Array<AttachmentFile & { __tempID?: string }>,
            attachmentUploadCounter: 0,

            toToogleShareInFeed: false,

            planOptions: [] as UserFilterOption[],
            selectedPlans: [] as UserFilterOption[],
            availablePlanIds: [] as Array<string | number>,
            unlockPlans: [] as any[],
            loadingUnlockPlans: false,
            pendingStreamPostIDs: [] as string[],
            pendingStreamPostIcon: 'chevron-up',
            pageFeedRecoveryPageID: null as string | null,
        };
    },
    watch: {
        preview(val) {
            if (!this.page || !this.page.ID || !this.page.Paid) {
                return;
            }

            this.resetFeedState();

            if (!val && !this.pagePreviewFlag) {
                this.getPageFeed();
            }
        },
        inviteOnly(val) {
            if (val) {
                this.approvalBased = false;
                this.open = false;
                this.page.JoinStrategy = 0;
            }
        },

        approvalBased(val) {
            if (val) {
                this.inviteOnly = false;
                this.open = false;
                this.page.JoinStrategy = 1;
            }
        },

        open(val) {
            if (val) {
                this.inviteOnly = false;
                this.approvalBased = false;
                this.page.JoinStrategy = 2;
            }
        },
        pageSlug() {
            this.getPage();
        },
        page: {
            handler() {
                this.getPageFollowers();
                this.getPageOwners();
                this.getPageContributores();
                this.getPageChannel();
                this.getLinksInfos();
            },
        },
        'page.ID': {
            handler(pageID, previousPageID) {
                if (previousPageID) {
                    EventBus.$off(`POST_CREATE_2_${previousPageID}`, this.handleRealtimePostCreated);
                }
                this.pendingStreamPostIDs = [];
                if (pageID) {
                    // Page posts arrive through App's shared realtime connection.
                    EventBus.$on(`POST_CREATE_2_${pageID}`, this.handleRealtimePostCreated);
                }
            },
        },
        '$route.query.focuspostid': {
            handler(to) {
                this.focusPostID = this.getRouteFocusPostID();
            },
            immediate: true,
        },
        '$route.query.postpin': {
            handler(to) {
                this.focusPostID = this.getRouteFocusPostID();
            },
            immediate: true,
        },
        planOptions() {
            this.syncSelectedPlans();
        },
    },
    computed: {
        visibilityStatus(): string {
            return this.getPageVisibilityStatus();
        },
        isPrivateVisibility(): boolean {
            return this.visibilityStatus === PAGE_VISIBILITY.PRIVATE;
        },
        isCommunityVisibility(): boolean {
            return this.visibilityStatus === PAGE_VISIBILITY.COMMUNITY;
        },
        isPaidVisibility(): boolean {
            return this.visibilityStatus === PAGE_VISIBILITY.PAID;
        },
        legacyPrivateVisibility: {
            get() {
                return this.isPrivateVisibility;
            },
            set(val) {
                if (val) {
                    this.setPageVisibilityStatus(PAGE_VISIBILITY.PRIVATE);
                }
            },
        },
        legacyCommunityVisibility: {
            get() {
                return this.isCommunityVisibility;
            },
            set(val) {
                if (val) {
                    this.setPageVisibilityStatus(PAGE_VISIBILITY.COMMUNITY);
                }
            },
        },
        isPrivatePage(): boolean {
            return this.visibilityStatus === PAGE_VISIBILITY.PRIVATE;
        },
        selectedChannel() {
            return this.channelsForSelect.find((channel) => channel.Value === this.page?.ChannelID) || null;
        },
        channelsForSelect() {
            return (this.channelList || []).map((c) => ({ Name: c.Value, Value: c.ID }));
        },
        pageHeaderImageURL(): string {
            if (this.page && this.page.ImageURL && this.page.ImageURL.length > 0) {
                return this.page.ImageURL[0];
            }
            return '';
        },
        pagePreviewFlag(): boolean {
            return Boolean(get(this.page, 'Prieview', false) || get(this.page, 'Preview', false));
        },
        shouldShowFeedPreview(): boolean {
            return Boolean(this.pagePreviewFlag || (this.page?.Paid && this.preview));
        },
        paywallSectionIndex(): number {
            return get(this.page, 'Sections', []).findIndex((section) => section && section.Type === 4);
        },
        visibleSections() {
            const sections = get(this.page, 'Sections', []);
            const shouldHideSectionsBelowPaywall = Boolean(
                get(this.page, 'Preview', false) || this.shouldShowFeedPreview
            );
            if (!shouldHideSectionsBelowPaywall || this.paywallSectionIndex === -1) {
                return sections;
            }

            // Stop rendering right after the paywall divider when the page is shown in preview mode.
            return sections.slice(0, this.paywallSectionIndex + 1);
        },
        noContent() // if no sections and no image and no tags return true
        {
            return (
                this.visibleSections.length === 0 &&
                (!this.page.ImageURL || this.page.ImageURL.length === 0) &&
                (!this.page.Hashtag || this.page.Hashtag.length === 0)
            );
        },
        joinRequestSent(): boolean {
            if (this.joinStatus && this.joinStatus.Role === 4) {
                return true;
            }
            return false;
        },
        shouldShowMemberMatch(): boolean {
            if (!this.$store || !this.$store.state || !this.$store.state.space) {
                return false;
            }

            return !this.$store.state.space.MatchingOff;
        },
        canIEditIgnorePreview(): boolean {
            return this.amIOwner || (this.amIAdmin && this.page.SpaceID === this.me.SpaceID);
        },
        canIEdit(): boolean {
            return (this.amIOwner || (this.amIAdmin && this.page.SpaceID === this.me.SpaceID)) && !this.preview;
        },
        canISave(): boolean {
            return this.page.Title?.trim() !== '';
        },
        amINewToPage(): boolean {
            if (!this.amIOwner && !this.amIContributor && !this.amIFollowing) {
                return true;
            }
            return false;
        },
        amIOwner(): boolean {
            if (!this.page.Owner) {
                return false;
            }
            // check if page.Owners contains user.ID
            return this.page.Owner && this.page.Owner.includes(this.me.ID);
        },
        amIContributor(): boolean {
            if (!this.page.Contributor) {
                return false;
            }

            if (this.page.UserID === this.me.ID) {
                return true;
            }
            // check if page.Contributor contains user.ID
            return this.page.Contributor && this.page.Contributor.includes(this.me.ID);
        },
        amIAdmin(): boolean {
            if (!this.me.Permissions) {
                return false;
            }
            // check if me.Permissions contain space_admin
            return this.me.Permissions && this.me.Permissions.includes('space_admin');
        },
        amIFollowing(): boolean {
            // check if page.FollowedBy contains user.ID
            if (!this.page.FollowedBy) {
                return false;
            }
            return this.page.FollowedBy && this.page.FollowedBy.includes(this.me.ID);
        },
        channelName(): string {
            return upperFirst(toLower(this.channel?.Value));
        },
        pageUrl(): string {
            if (!this.page || !this.page.Slug) return '';
            return `${window.location.origin}/page/${this.page.Slug}`;
        },
        pageAttachments() {
            const attachments = get(this.page, 'Attachments', []);
            if (!attachments || attachments.length === 0) {
                return [];
            }
            return attachments.map((attachment) => normalizeAttachmentFile(attachment));
        },
        attachmentsLimit() {
            return 5;
        },
        attachmentsForDisplay() {
            if (this.pageAttachments.length <= this.attachmentsLimit) {
                return this.pageAttachments;
            }
            return this.pageAttachments.slice(0, this.attachmentsLimit);
        },
        shouldShowAttachmentsSection() {
            return this.canIEdit || this.pageAttachments.length > 0 || this.pendingPageAttachments.length > 0;
        },
        pageCreator() {
            if (this.page.UserID && this.members?.length > 0) {
                return this.members.filter((i) => i.ID === this.page.UserID)[0];
            }
            return {};
        },
        canIPost() {
            return this.amIOwner || this.amIContributor;
        },
        canCreateFeedPost() {
            return this.$store.state.permissions && this.$store.state.permissions['feed.post'] === true;
        },
        hasUnlockablePlans() {
            return this.unlockPlans.length > 0;
        },
        unlockModalDescription() {
            return this.loadingUnlockPlans || this.hasUnlockablePlans
                ? this.$t('unlockPageModalPlansDescription')
                : this.$t('unlockPageModalOwnersDescription');
        },
        unlockPageOwners() {
            const owners = (
                this.owners.length > 0 ? this.owners : this.members.filter((member) => member.Role === 'Owner')
            ) as Array<{
                ID: string | number;
                Name?: string;
                Role?: string;
            }>;
            return uniqBy(
                owners.filter((owner) => owner && owner.ID),
                (owner) => owner.ID
            );
        },
    },
    created() {
        window.addEventListener('scroll', this.scroll);
        window.addEventListener('scroll', this.handlePendingStreamPostScroll, { passive: true });
        this.getPage();
    },
    mounted() {
        EventBus.$on('REALTIME_STREAM_RECONNECTED', this.handleRealtimeStreamReconnected);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scroll);
        window.removeEventListener('scroll', this.handlePendingStreamPostScroll);
        EventBus.$off('REALTIME_STREAM_RECONNECTED', this.handleRealtimeStreamReconnected);
        if (this.page?.ID) {
            EventBus.$off(`POST_CREATE_2_${this.page.ID}`, this.handleRealtimePostCreated);
        }
    },
    methods: {
        getSectionKey,
        get,
        upperFirst,
        toLower,
        map,
        cloneDeep,
        getPageVisibilityStatus() {
            const isPublished = Boolean(get(this.page, 'Published', false));
            const isPaid = Boolean(get(this.page, 'Paid', false));

            if (isPublished && isPaid) {
                return PAGE_VISIBILITY.PAID;
            }

            if (isPublished) {
                return PAGE_VISIBILITY.COMMUNITY;
            }

            return PAGE_VISIBILITY.PRIVATE;
        },
        setPageVisibilityStatus(status) {
            const publishedAt = Math.floor(Date.now() / 1000);

            // Keep all visibility transitions in one place so the UI and save payload use the same rules.
            if (status === PAGE_VISIBILITY.PAID) {
                this.$set(this.page, 'Published', true);
                this.$set(this.page, 'Paid', true);
                this.$set(this.page, 'PublishedAt', publishedAt);
                return;
            }

            if (status === PAGE_VISIBILITY.COMMUNITY) {
                this.$set(this.page, 'Published', true);
                this.$set(this.page, 'Paid', false);
                this.$set(this.page, 'PublishedAt', publishedAt);
                this.removePaywallSections();
                return;
            }

            this.$set(this.page, 'Published', false);
            this.$set(this.page, 'Paid', false);
            this.$set(this.page, 'PublishedAt', 0);
            this.removePaywallSections();
        },
        setPrefilledContentForSharingInFeed() {
            if (!this.canCreateFeedPost) return;
            const cfg = {
                Type: 'post',
                ParentID: this.page.ID,
                ParentType: 2,
                FeatureContentID: this.page.ID, // this page is the featured content and parent
                FeaturedContentType: 2,
                FeedDisplay: 2, // only
                LockParentDestination: false,
                LockFeedDestination: true,
                DisablePageSearch: true,
                Title: this.page.Title,
                ImageURL: this.page.ImageURL,
                Slug: this.page.Slug,
            };

            if (!this.canIPost) {
                cfg.ParentID = '';
                cfg.ParentType = 0;
                cfg.FeedDisplay = 0;
                cfg.LockFeedDestination = true;
                cfg.LockParentDestination = true;
            }
            EventBus.$emit('STARTNEWPOST', {
                cfg,
            });
        },
        setPrefilledContentOnPostCreation() {
            // if feature flag for new post in pages is on
            const cfg = {
                Type: 'post',
                ParentID: this.page.ID,
                ParentType: 2,
                FeedDisplay: 1,
                LockParentDestination: true,
                LockFeedDestination: false,
                Title: this.page.Title,
                ImageURL: this.page.ImageURL,
                Slug: this.page.Slug,
            };

            if (this.page.Paid || !this.page.Published) {
                cfg.LockFeedDestination = true;
            }
            this.$refs.posteditor.show(cfg);
        },
        resetFeedState() {
            this.updates = [];
            this.updatesBank = [];
            this.updatesNextPage = null;
            this.pendingStreamPostIDs = [];
        },
        ensurePaywallSectionExists() {
            if (!this.isPaidVisibility) {
                return;
            }

            if (!Array.isArray(this.page.Sections)) {
                this.page.Sections = [];
            }

            // Paid pages must always contain a paywall divider so protected content has a clear cutoff.
            if (!this.page.Sections.some((section) => section && section.Type === 4)) {
                this.page.Sections.push({
                    Type: 4,
                    Content: '',
                });
            }
        },
        removePaywallSections() {
            if (!Array.isArray(this.page.Sections) || this.page.Sections.length === 0) {
                return;
            }

            const sectionsWithoutPaywall = this.page.Sections.filter((section) => !section || section.Type !== 4);
            if (sectionsWithoutPaywall.length === this.page.Sections.length) {
                return;
            }

            // Switching away from paid should immediately remove the paywall divider from the unsaved editor state.
            this.$set(this.page, 'Sections', sectionsWithoutPaywall);
            this.sectionsRerenderKey += 1;
        },
        async showUnlockModal() {
            const modal = this.$refs.unlockPageModal as { show?: () => void } | undefined;
            if (!modal?.show) {
                return;
            }

            this.loadingUnlockPlans = Boolean(this.page?.Paid && this.availablePlanIds.length);
            modal.show();
            await this.loadUnlockPlans();
        },
        async loadUnlockPlans() {
            this.unlockPlans = [];

            if (!this.page?.Paid || !this.availablePlanIds.length) {
                this.loadingUnlockPlans = false;
                return;
            }

            this.loadingUnlockPlans = true;

            try {
                // Fetch the plans referenced by the paid page so hidden or inactive entries can be excluded.
                const planIds = uniq(this.availablePlanIds.map((planId) => String(planId)).filter(Boolean));
                const fetchedPlans = await Promise.all(
                    planIds.map(async (planId) => {
                        try {
                            const response = await axios({
                                method: 'GET',
                                url: `space/plan/${planId}`,
                                withCredentials: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            });

                            return response?.data || null;
                        } catch (error) {
                            if (error?.response?.status !== 404) {
                                console.log(error);
                            }
                            return null;
                        }
                    })
                );
                this.unlockPlans = uniqBy(
                    fetchedPlans.filter((plan) => plan?.ID && !plan.Hidden && plan.Active !== false),
                    'ID'
                );
            } finally {
                this.loadingUnlockPlans = false;
            }
        },
        openPlanChangeInNewTab(planID) {
            if (!planID) {
                return;
            }

            const redirectTo = this.$router.resolve({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    confettie: 'true',
                },
            }).route.fullPath;

            this.$router.push({
                path: `/account/plan/change/${planID}`,
                query: {
                    redirectTo,
                },
            });
        },
        takeContact(userObj) {
            const thread = {
                Participants: [this.me.ID, userObj.ID],
            };

            axios({
                method: 'POST',
                url: '/chat/t',
                withCredentials: true,
                data: JSON.stringify(thread),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$router.push(`/messenger/${response.data.ID}`);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        triggerQueryConfettie() {
            if (!this.$route || !this.$route.query || !this.$route.query.confettie) {
                return;
            }

            const nextQuery = { ...this.$route.query };
            delete nextQuery.confettie;

            this.$nextTick(() => {
                [150, 250, 180].forEach((delay) => {
                    window.setTimeout(() => {
                        jsConfetti.addConfetti();
                    }, delay);
                });

                this.$router
                    .replace({
                        path: this.$route.path,
                        query: nextQuery,
                    })
                    .catch(() => {});
            });
        },
        makeOwner(index, member) {
            // remove from contributors
            const newOwner = {
                ProjectID: this.page.ID,
                UserID: member.ID,
            };
            this.$store
                .dispatch('removeContributor', newOwner)
                .then((response) => {
                    this.$store
                        .dispatch('addOwner', newOwner)
                        .then((response2) => {
                            if (response2) {
                                this.members[index].Role = 'Owner';
                                this.sortMembers();

                                EventBus.$emit('INFO', {
                                    Message: this.$t('labels.changessaved'),
                                    Details: '',
                                });
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            EventBus.$emit('ERROR', {
                                Message: this.$t('labels.failedGeneric'),
                                Details: '',
                            });
                        });
                })
                .catch((error) => {
                    if (error.response && error.response.status === 404) {
                        this.$store
                            .dispatch('addOwner', newOwner)
                            .then((response2) => {
                                if (response2) {
                                    this.members[index].Role = 'Owner';
                                    this.sortMembers();

                                    EventBus.$emit('INFO', {
                                        Message: this.$t('labels.changessaved'),
                                        Details: '',
                                    });
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                                EventBus.$emit('ERROR', {
                                    Message: this.$t('labels.failedGeneric'),
                                    Details: '',
                                });
                            });
                    } else {
                        console.log(error);
                        EventBus.$emit('ERROR', {
                            Message: this.$t('labels.failedGeneric'),
                            Details: '',
                        });
                    }
                });

            // add to owners
        },
        makeContributor(index, member) {
            // remove from owners
            const newContributor = {
                ProjectID: this.page.ID,
                UserID: member.ID,
            };
            this.$store
                .dispatch('removeOwner', newContributor)
                .then((response) => {
                    this.$store
                        .dispatch('addContributor', newContributor)
                        .then((response2) => {
                            if (response2) {
                                this.members[index].Role = 'Contributor';
                                this.sortMembers();

                                EventBus.$emit('INFO', {
                                    Message: this.$t('labels.changessaved'),
                                    Details: '',
                                });
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            EventBus.$emit('ERROR', {
                                Message: this.$t('labels.failedGeneric'),
                                Details: '',
                            });
                        });
                })
                .catch((error) => {
                    if (error.response && error.response.status === 404) {
                        this.$store
                            .dispatch('addContributor', newContributor)
                            .then((response2) => {
                                if (response2) {
                                    this.members[index].Role = 'Contributor';
                                    this.sortMembers();

                                    EventBus.$emit('INFO', {
                                        Message: this.$t('labels.changessaved'),
                                        Details: '',
                                    });
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                                EventBus.$emit('ERROR', {
                                    Message: this.$t('labels.failedGeneric'),
                                    Details: '',
                                });
                            });
                    } else {
                        console.log(error);
                        EventBus.$emit('ERROR', {
                            Message: this.$t('labels.failedGeneric'),
                            Details: '',
                        });
                    }
                });
            // add to contributors
        },
        remove(index, member) {
            const newContributor = {
                ProjectID: this.page.ID,
                UserID: member.ID,
            };

            const funcName = member.Role === 'Owner' ? 'removeOwner' : 'removeContributor';

            this.$store
                .dispatch(funcName, newContributor)
                .then((response) => {
                    // if user is in followers list change role to follower
                    const i = get(this.page, 'FollowedBy', []).findIndex((ID) => ID === member.ID);
                    if (i !== -1) {
                        this.members[index].Role = 'Follower';
                    } else {
                        this.members.splice(index, 1);
                    }

                    // eslint-disable-next-line no-empty
                    if (member.Role === 'Owner') {
                        this.page.Owner = get(this.page, 'Owners', []).filter((ID: any) => ID !== member.ID);
                    } else {
                        this.page.Contributor = get(this.page, 'Contributors', []).filter(
                            (ID: any) => ID !== member.ID
                        );
                    }

                    EventBus.$emit('INFO', {
                        Message: this.$t('labels.changessaved'),
                        Details: '',
                    });
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: '',
                    });
                });
        },
        addMembers() {
            // iterate over membersCandidates and add them to page as contributors
            this.membersCandidates.forEach((m) => {
                // if user is already in the list, update the role to Contributor
                const found = this.members.find((member) => member.ID === m.ID);
                if (found && found.Role === 'Follower') {
                    found.Role = 'Contributor';
                    // skip this user
                    return;
                }

                const newContributor = {
                    ProjectID: this.page.ID,
                    UserID: m.ID,
                };

                this.$store
                    .dispatch('addContributor', newContributor)
                    .then((response) => {
                        if (response) {
                            this.members.push({
                                ID: m.ID,
                                Name: m.Name,
                                Slug: m.Slug,
                                ImageURL: m.ImageURL,
                                Role: 'Contributor',
                            });

                            EventBus.$emit('INFO', {
                                Message: this.$t('labels.changessaved'),
                                Details: '',
                            });

                            // remove m from membersCandidates
                            this.membersCandidates = this.membersCandidates.filter((c) => c.ID !== m.ID);
                            this.sortMembers();
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        EventBus.$emit('ERROR', {
                            Message: this.$t('labels.failedGeneric'),
                            Details: '',
                        });
                    });
            });
        },

        addLink() {
            if (!this.newlink) {
                return;
            }

            const normalizedLink = this.normalizePageLink(this.newlink);

            if (!normalizedLink || !isURL(normalizedLink)) {
                EventBus.$emit('ERROR', {
                    Message: this.$t('invalidLink'),
                    Details: '',
                });
                return;
            }

            if (!this.page.Links) {
                this.$set(this.page, 'Links', []);
            }

            const normalizedExistingLinks = this.page.Links.map((link: string | URL) =>
                this.normalizePageLink(link)
            ).filter((link: string) => Boolean(link));

            if (normalizedExistingLinks.includes(normalizedLink)) {
                this.newlink = '';
                return;
            }

            this.page.Links.push(normalizedLink);
            this.newlink = '';
            this.getLinksInfos();
            this.updatePage();
        },
        removeLink(link) {
            // Compare canonical URLs so links saved before normalization can still be removed.
            this.page.Links = this.page.Links.filter(
                (pageLink: string | URL) => this.normalizePageLink(pageLink) !== link.url
            );
            this.getLinksInfos();
            this.updatePage();
        },
        getRouteFocusPostID() {
            return (
                get(this, '$route.query.focuspostid', '') ||
                get(this, '$route.query.postpin', '') ||
                ''
            ).toString();
        },
        scrollRefIntoView(refName) {
            this.$nextTick(() => {
                const refEl = this.$refs[refName];
                const target = Array.isArray(refEl) ? refEl[0] : refEl;
                if (!target) return;
                const el = target.$el || target;
                if (el && el.scrollIntoView) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        async handleRealtimePostCreated(post) {
            try {
                if (
                    !post ||
                    typeof post !== 'object' ||
                    this.shouldShowFeedPreview ||
                    String(post.ParentID) !== String(this.page?.ID)
                ) {
                    return;
                }

                const entry = {
                    object: cloneDeep(post),
                    space: get(this, 'page.Space', get(this, '$store.state.space', {})),
                } as Record<string, any>;
                const authorID = entry.object.AuthorID;
                if (!entry.object.Author && authorID) {
                    const knownEntry = [...this.updates, ...this.updatesBank].find(
                        (candidate) => get(candidate, 'object.AuthorID') === authorID
                    );
                    entry.object.Author = get(knownEntry, 'object.Author', null);
                    if (!entry.object.Author) {
                        try {
                            const usersResponse = await axios({
                                method: 'POST',
                                url: '/user/listbyids',
                                data: { IDS: [{ ID: authorID }] },
                                withCredentials: true,
                                headers: { 'Content-Type': 'application/json' },
                            });
                            const author = get(usersResponse, 'data.Users.0');
                            if (author) {
                                entry.object.Author = {
                                    ID: get(author, 'ID'),
                                    Name: get(author, 'Profile.Name'),
                                    Slug: get(author, 'Slug'),
                                    ImageURL: get(author, 'Profile.ImageURL'),
                                    Bio: get(author, 'Profile.Bio'),
                                };
                            }
                        } catch (error) {
                            // A missing author must not prevent delivery of the realtime post.
                            console.error('Failed to load realtime page post author', error);
                        }
                    }
                }

                // Ignore an in-flight author lookup if navigation changed the active page.
                if (String(post.ParentID) !== String(this.page?.ID)) return;

                entry.object.CreatedAt = entry.object.CreatedAt || entry.object.Created;
                entry.object.UpdatedAt = entry.object.UpdatedAt || entry.object.Updated;
                entry.object.Images = map(get(entry, 'object.Images', get(entry, 'object.ImageURLs', [])), (image) =>
                    image?.ImageURL ? image : { ImageURL: image?.url || image }
                );

                const entryID = get(entry, 'object.ID', '').toString();
                if (!entryID) return;

                const existingUpdateIndex = this.updates.findIndex(
                    (candidate) => get(candidate, 'object.ID', '').toString() === entryID
                );
                const existingBankIndex = this.updatesBank.findIndex(
                    (candidate) => get(candidate, 'object.ID', '').toString() === entryID
                );
                if (existingUpdateIndex > -1) {
                    this.updates.splice(existingUpdateIndex, 1, {
                        ...entry,
                        wasUpdated: this.updates[existingUpdateIndex]?.wasUpdated || false,
                        streamUpdateHandled: this.updates[existingUpdateIndex]?.streamUpdateHandled || false,
                        pendingStreamIndicatorEligible:
                            this.updates[existingUpdateIndex]?.pendingStreamIndicatorEligible || false,
                    });
                } else if (existingBankIndex > -1) {
                    this.updatesBank.splice(existingBankIndex, 1, entry);
                } else {
                    entry.wasUpdated = true;
                    entry.streamUpdateHandled = false;
                    entry.pendingStreamIndicatorEligible = true;
                    this.updates.unshift(entry);
                    // App owns the browser-title indicator shared by all realtime feeds.
                    EventBus.$emit('TAB_ATTENTION');
                }

                this.syncFeedOrder();
            } catch (error) {
                console.error('Failed to process realtime page post_create message', error);
            }
        },
        async handleRealtimeStreamReconnected() {
            const pageID = this.page?.ID?.toString();
            if (this.pageFeedRecoveryPageID === pageID || this.shouldShowFeedPreview || !pageID) return;

            this.pageFeedRecoveryPageID = pageID;
            try {
                await this.refreshPageFeedAfterRealtimeStreamConnected();
            } catch (error) {
                console.error('Failed to refresh page feed after realtime stream reconnect', error);
            } finally {
                // Do not clear a newer page's recovery when navigation happened during this request.
                if (this.pageFeedRecoveryPageID === pageID) this.pageFeedRecoveryPageID = null;
            }
        },
        async refreshPageFeedAfterRealtimeStreamConnected() {
            const pageID = this.page?.ID;
            if (!pageID) return;

            const response = await axios({
                method: 'GET',
                url: `/page/feed/${pageID}`,
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' },
            });
            if (String(pageID) !== String(this.page?.ID) || this.shouldShowFeedPreview) return;

            const feedObjects =
                get(response, 'data.objects', null) || (Array.isArray(response?.data) ? response.data : null) || [];
            if (!Array.isArray(feedObjects) || feedObjects.length === 0) return;

            let feedEntries = feedObjects.map((entry) =>
                get(entry, 'object') ? cloneDeep(entry) : { object: cloneDeep(entry) }
            );
            const authorIDs = uniq(feedEntries.map((entry) => get(entry, 'object.AuthorID')).filter(Boolean));
            let users = [];

            if (authorIDs.length > 0) {
                try {
                    const usersResponse = await axios({
                        method: 'POST',
                        url: '/user/listbyids',
                        data: { IDS: map(authorIDs, (id) => ({ ID: id })) },
                        withCredentials: true,
                        headers: { 'Content-Type': 'application/json' },
                    });
                    users = map(get(usersResponse, 'data.Users', []), (user) => ({
                        ID: get(user, 'ID'),
                        Name: get(user, 'Profile.Name'),
                        Slug: get(user, 'Slug'),
                        ImageURL: get(user, 'Profile.ImageURL'),
                        Bio: get(user, 'Profile.Bio'),
                    }));
                } catch (error) {
                    // Feed recovery still succeeds when an author lookup is temporarily unavailable.
                    console.error('Failed to load recovered page post authors', error);
                }
            }
            if (String(pageID) !== String(this.page?.ID) || this.shouldShowFeedPreview) return;

            feedEntries = feedEntries.map((entry) => {
                if (!entry.object || typeof entry.object !== 'object') return entry;

                const normalizedEntry = {
                    ...entry,
                    space: entry.space || get(this, 'page.Space', get(this, '$store.state.space', {})),
                    object: { ...entry.object },
                };
                const authorID = normalizedEntry.object.AuthorID;
                if (!normalizedEntry.object.Author && users.length > 0) {
                    normalizedEntry.object.Author = users.find((user) => user.ID === authorID);
                }
                normalizedEntry.object.Images = map(
                    get(normalizedEntry, 'object.Images', get(normalizedEntry, 'object.ImageURLs', [])),
                    (image) => (image?.ImageURL ? image : { ImageURL: image?.url || image })
                );
                if (!normalizedEntry.object.ParentID) normalizedEntry.object.ParentID = pageID;
                if (!normalizedEntry.object.ParentType) normalizedEntry.object.ParentType = 2;

                return normalizedEntry;
            });

            const incomingEntryIDs = feedEntries.map((entry) => get(entry, 'object.ID', '').toString()).filter(Boolean);
            const knownEntryIDs = new Set(
                [...this.updates, ...this.updatesBank]
                    .map((entry) => get(entry, 'object.ID', '').toString())
                    .filter(Boolean)
            );
            if (!incomingEntryIDs.some((entryID) => !knownEntryIDs.has(entryID))) return;

            feedEntries.forEach((entry) => {
                const entryID = get(entry, 'object.ID', '').toString();
                if (!entryID) return;

                const existingUpdateIndex = this.updates.findIndex(
                    (candidate) => get(candidate, 'object.ID', '').toString() === entryID
                );
                const existingBankIndex = this.updatesBank.findIndex(
                    (candidate) => get(candidate, 'object.ID', '').toString() === entryID
                );
                if (existingUpdateIndex > -1) {
                    this.updates.splice(existingUpdateIndex, 1, {
                        ...entry,
                        wasUpdated: this.updates[existingUpdateIndex]?.wasUpdated || false,
                        streamUpdateHandled: this.updates[existingUpdateIndex]?.streamUpdateHandled || false,
                        pendingStreamIndicatorEligible:
                            this.updates[existingUpdateIndex]?.pendingStreamIndicatorEligible || false,
                    });
                    return;
                }
                if (existingBankIndex > -1) {
                    this.updatesBank.splice(existingBankIndex, 1, entry);
                    return;
                }

                this.updates.push({
                    ...entry,
                    wasUpdated: true,
                    streamUpdateHandled: false,
                });
            });

            this.syncFeedOrder();
        },
        handlePostUpdated(post) {
            if (post.pendingStreamIndicatorEligible || post.streamUpdateHandled !== undefined) {
                this.handleStreamPostUpdated(post);
                return;
            }
            this.scrollRefIntoView(`post${post.object.ID}`);
        },
        handleStreamPostUpdated(post) {
            if (post.streamUpdateHandled) return;

            this.$set(post, 'streamUpdateHandled', true);
            if (!post.pendingStreamIndicatorEligible) return;

            this.$set(post, 'pendingStreamIndicatorEligible', false);
            const postID = get(post, 'object.ID', '').toString();
            if (!postID || this.pendingStreamPostIDs.includes(postID) || this.isStreamPostVisible(postID)) return;

            // Keep the highlight pending until the member reveals the new post.
            this.$set(post, 'wasUpdated', false);
            this.pendingStreamPostIDs.push(postID);
            this.updatePendingStreamPostIcon();
        },
        isStreamPostVisible(postID: string) {
            const refEl = this.$refs[`post${postID}`];
            const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
            const postElement = postComponent?.$el || postComponent;
            if (!postElement?.getBoundingClientRect) return false;

            const { top, bottom } = postElement.getBoundingClientRect();
            return top < window.innerHeight && bottom > 0;
        },
        handlePendingStreamPostScroll() {
            const visiblePostID = this.pendingStreamPostIDs.find((postID) => this.isStreamPostVisible(postID));
            if (!visiblePostID) {
                this.updatePendingStreamPostIcon();
                return;
            }

            const visiblePost = this.updates.find((entry) => get(entry, 'object.ID', '').toString() === visiblePostID);
            if (visiblePost) this.$set(visiblePost, 'wasUpdated', true);
            this.removePendingStreamPostID(visiblePostID);
        },
        updatePendingStreamPostIcon() {
            const targetPost = this.updates.find((entry) =>
                this.pendingStreamPostIDs.includes(get(entry, 'object.ID', '').toString())
            );
            const targetPostID = get(targetPost, 'object.ID', '').toString();
            if (!targetPostID) return;

            const refEl = this.$refs[`post${targetPostID}`];
            const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
            const postElement = postComponent?.$el || postComponent;
            if (!postElement?.getBoundingClientRect) return;
            this.pendingStreamPostIcon =
                postElement.getBoundingClientRect().top > window.innerHeight ? 'chevron-down' : 'chevron-up';
        },
        removePendingStreamPostID(postID: string | number = '') {
            const normalizedPostID = postID ? postID.toString() : '';
            if (!normalizedPostID) return;
            this.pendingStreamPostIDs = this.pendingStreamPostIDs.filter((id) => id !== normalizedPostID);
            this.$nextTick(() => this.updatePendingStreamPostIcon());
        },
        scrollToPendingStreamPost() {
            const targetPost = this.updates.find((entry) =>
                this.pendingStreamPostIDs.includes(get(entry, 'object.ID', '').toString())
            );
            const targetPostID = get(targetPost, 'object.ID');
            if (!targetPostID) {
                this.pendingStreamPostIDs = [];
                return;
            }

            this.$set(targetPost, 'wasUpdated', true);
            this.$nextTick(() => {
                const refEl = this.$refs[`post${targetPostID}`];
                const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
                const postElement = postComponent?.$el || postComponent;
                if (postElement?.scrollIntoView) {
                    postElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                this.removePendingStreamPostID(targetPostID);
            });
        },
        syncFeedOrder() {
            this.updates = this.updates
                .filter(Boolean)
                .sort(
                    (a, b) =>
                        Number(get(b, 'object.CreatedAt', get(b, 'object.Created', 0))) -
                        Number(get(a, 'object.CreatedAt', get(a, 'object.Created', 0)))
                )
                .filter(
                    (entry, index, entries) =>
                        index ===
                        entries.findIndex(
                            (candidate) =>
                                get(candidate, 'object.ID', '').toString() === get(entry, 'object.ID', '').toString()
                        )
                );
        },
        getLinksInfos() {
            const pageLinks = uniq(
                get(this.page, 'Links', [])
                    .map((link: string | URL) => this.normalizePageLink(link))
                    .filter((link) => Boolean(link))
            );

            if (pageLinks.length === 0) {
                this.links = [];
                return;
            }

            // Rebuild the rendered link list from the persisted source so page saves cannot append duplicates.
            this.links = pageLinks.map((link: string) => {
                const url = new URL(link);

                return {
                    title: url.hostname,
                    url: link,
                };
            });

            pageLinks.forEach((link: string) => {
                const url = new URL(link);

                axios({
                    method: 'GET',
                    url: `/dashboard/og?url=${link}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        const title = get(response, 'data.title');
                        const linkIndex = this.links.findIndex((item) => item.url === link);
                        if (linkIndex === -1) {
                            return;
                        }

                        this.$set(this.links, linkIndex, {
                            title: typeof title === 'string' && title.length >= 3 ? title : url.hostname,
                            url: link,
                        });
                    })
                    .catch((error) => {
                        console.log('error', error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            });
        },
        normalizePageLink(link: string | URL) {
            const value = `${link || ''}`.trim();
            if (!value) {
                return '';
            }

            // Store page links canonically so Enter plus Save cannot create visually duplicated variants.
            return value.match(/^https?:\/\//i) ? value : `https://${value}`;
        },

        acceptRequest(request) {
            const req = {
                UserID: request.UserID,
                PageID: this.page.ID,
            };
            axios({
                method: 'POST',
                url: `/page/accept-join-request`,
                data: req,
            })
                .then((response) => {
                    this.pendingRequests = this.pendingRequests.filter((r) => r.UserID !== request.UserID);

                    // add user to members list and page.Contributor list if not already there
                    // if user is already in the list, update the role to Contributor
                    const index = this.members.findIndex((m) => m.ID === request.UserID);
                    if (index === -1) {
                        this.members.push({
                            ID: request.UserID,
                            Name: request.User.Name,
                            Slug: request.User.Slug,
                            ImageURL: request.User.ImageURL,
                            Role: 'Contributor',
                        });
                        this.page.Contributor.push(request.UserID);
                    } else {
                        this.members[index].Role = 'Contributor';
                    }

                    EventBus.$emit('INFO', {
                        Message: this.$t('joinRequestAccepted'),
                        Details: '',
                    });
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: '',
                    });
                });
        },

        rejectRequest(request) {
            const req = {
                UserID: request.UserID,
                PageID: this.page.ID,
            };

            axios({
                method: 'POST',
                url: `/page/reject-join-request`,
                data: req,
            })
                .then((response) => {
                    this.pendingRequests = this.pendingRequests.filter((r) => r.UserID !== request.UserID);

                    EventBus.$emit('INFO', {
                        Message: this.$t('joinRequestRejected'),
                        Details: '',
                    });
                })
                .catch((error) => {
                    console.log(error);

                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: '',
                    });
                });
        },

        selectChannel(channel) {
            // CoSelect emits a null value when the optional channel is cleared.
            this.page.ChannelID = get(channel, 'Value') || '';
            if (!this.page.ChannelID) {
                this.channel = null;
            } else {
                const ch = this.channelList.find((c) => c.ID === this.page.ChannelID);
                if (ch && ch.Slug) {
                    this.channel = ch;
                }
            }
        },

        tagsChanged(tags) {
            const tmp = uniq(tags);
            this.page.Hashtag = tmp;
        },

        getPendingRequests() {
            if (!this.amIAdmin && !this.amIContributor) {
                return;
            }

            axios({
                method: 'GET',
                url: `/page/join-requests/${this.page.ID}`,
            })
                .then((response) => {
                    const tmp = get(response, 'data.Participations', []);
                    // map list of contributor ids from page.Contributor to {IDS: [{ID: 1}, {ID: 2}]} to send as payload

                    const ids = tmp.map((p) => ({ ID: p.UserID }));
                    if (!ids.length) {
                        return;
                    }

                    const requestBody = { IDS: ids };
                    axios({
                        method: 'POST',
                        url: `/user/listbyids`,
                        data: requestBody,
                    })
                        .then((response) => {
                            if (response.data && response.data.Users) {
                                // map response data to User object
                                tmp.forEach((participant) => {
                                    const item = response.data.Users.find((u) => u.ID === participant.UserID);
                                    if (item) {
                                        participant.User = {
                                            ID: item.ID,
                                            Name: get(item, 'Profile.Name', ''),
                                            Slug: item.Slug,
                                            ImageURL: get(item, 'Profile.ImageURL', ''),
                                        };
                                    }
                                });

                                this.pendingRequests = [];
                                this.pendingRequests = tmp;
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        removeCandidate(index) {
            this.membersCandidates.splice(index, 1);
        },
        selectCandidate(user) {
            const u = get(user, 'value', null);
            if (!u) {
                return;
            }
            this.membersCandidates.push({
                ...u,
                Role: 'Contributor',
            });
        },

        searchUsers(query, source) {
            // search for users
            return new Promise((resolve, reject) => {
                // exit if query is less than 2 characters
                if (!query || query.length < 2) {
                    resolve([]);
                    return;
                }
                // fetch the search results
                axios({
                    method: 'GET',
                    url: `/search/user/${query}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    cancelToken: source ? source.token : null,
                })
                    .then((response) => {
                        const results = get(response, 'data', []);
                        // filter out users that are already in the membersCandidates list  or in the members list
                        const filtered = results.filter((el) => {
                            const found = this.membersCandidates.find((m) => m.ID === el.ID);
                            if (found) {
                                return false;
                            }
                            const found2 = this.members.find((m) => m.ID === el.ID);
                            if (found2) {
                                return false;
                            }
                            return true;
                        });

                        const mapped = filtered.map((el) => {
                            // if the user is not in the same space, show space thumbnail
                            let spaceIcon = null;
                            if (get(el, 'Space.ID', null) !== this.$store?.state?.space?.ID) {
                                spaceIcon = {
                                    imageURL: get(el, 'Space.FaviconURL', null),
                                    text: get(el, 'Space.Name', null),
                                    color: get(el, 'Space.PrimaryColor', null),
                                };
                            }
                            return {
                                thumbnailLabel: spaceIcon,
                                label: get(el, 'Profile.Name', ''),
                                thumbnail: get(el, 'Profile.ImageURL', ''),
                                disabled: false,
                                value: el,
                            };
                        });
                        resolve(mapped);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        join() {
            axios({
                method: 'POST',
                url: `/page/join/${this.page.ID}`,
            })
                .then((response) => {
                    this.joinStatus = response.data;

                    if (this.joinStatus.Role === 2) {
                        this.members.push({
                            ID: this.$store.state.me.ID,
                            Name: this.$store.state.me.Profile.Name,
                            Slug: this.$store.state.me.Slug,
                            ImageURL: get(this.$store.state.me, 'Profile.ImageURL', ''),
                            Role: 'Contributor',
                        });

                        this.page.Contributor.push(this.$store.state.me.ID);

                        EventBus.$emit('INFO', {
                            Message: this.$t('joinedPageAsContributor'),
                            Details: '',
                        });
                    } else {
                        EventBus.$emit('INFO', {
                            Message: this.$t('joinRequestSent'),
                            Details: '',
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getJoinSatatus() {
            axios({
                method: 'GET',
                url: `/page/join/${this.page.ID}`,
            })
                .then((response) => {
                    if (response.data) {
                        this.joinStatus = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        sortMembers() {
            const members = this.members as Array<{
                ID: string | number;
                Name: string;
                Role?: string;
            }>;
            if (!members) {
                return;
            }
            // iterate over members and remove duplicates with lower role even if there are multiple roles for the same user
            members.forEach((m) => {
                const index = members.findIndex((member) => member.ID === m.ID);
                if (index !== -1) {
                    const roles = members.filter((member) => member.ID === m.ID).map((member) => member.Role);
                    if (roles.includes('Owner')) {
                        m.Role = 'Owner';
                    } else if (roles.includes('Contributor')) {
                        m.Role = 'Contributor';
                    } else {
                        m.Role = 'Follower';
                    }
                }
            });
            const m = uniqBy(members, 'ID') as typeof members;

            this.members = m.sort((a, b) => {
                if (a.Role === 'Owner') return -1;
                if (b.Role === 'Owner') return 1;
                if (a.Role === 'Contributor') return -1;
                if (b.Role === 'Contributor') return 1;
                return 0;
            });

            // stable sort by Name if role is the same
            this.members.sort((a, b) => {
                if (a.Role === b.Role) {
                    return a.Name.localeCompare(b.Name);
                }
                return 0;
            });
        },
        addedPost(post = {}) {
            const postID = get(post, 'object.ID', '').toString();
            const existingIndex = this.updates.findIndex((entry) => get(entry, 'object.ID', '').toString() === postID);

            // The event bus can deliver the post before CoPostEditor emits the create result.
            if (postID && existingIndex > -1) {
                this.updates.splice(existingIndex, 1, post);
                this.syncFeedOrder();
                return;
            }

            this.updatesBank = this.updatesBank.filter((entry) => get(entry, 'object.ID', '').toString() !== postID);
            this.updates.unshift(post);
            jsConfetti.addConfetti();
        },
        editPost(post = {}) {
            if (!post) return;
            // map post structure to editor structure
            const postObject = { ...get(post, 'object', {}) };
            const postToEdit = {
                ...postObject,
                Files: map(get(postObject, 'Images', get(postObject, 'ImageURLs', [])), (i) => ({
                    url: i?.ImageURL || i,
                })),
                Type: 'post',
                wasUpdated: true,
            };
            this.$refs.posteditor.show(postToEdit, true);
        },
        editedPost(post = {}) {
            const that = this;
            if (post && this.updates) {
                const updatedPost = post as Record<string, any>;
                updatedPost.wasUpdated = true;
                // find the post in the feed by id and update it
                const index = this.updates.findIndex((p) => get(p, 'object.ID') === get(updatedPost, 'object.ID'));
                if (index > -1) {
                    that.updates.splice(index, 1, updatedPost);
                }
            }
        },
        showMembers() {
            this.$refs.membersModal.show();
        },
        roleLabelForBadge(role: string): string {
            if (role === 'Owner') return this.$t('labels.owner');
            if (role === 'Contributor') return this.$t('labels.contributor');
            return this.$t(`labels.followerrole`);
        },
        /**
         * Maps a post object to a format suitable for rendering in the UI.
         *
         * This function extracts and transforms properties from the input post object,
         * handling both legacy and new post structures. It also processes image fields
         * and other metadata required for display.
         *
         * @param {any} post - The post object to map. Can be a raw post or an object with an 'object' property.
         * @returns {object} The mapped post object with normalized fields for rendering.
         *
         * @remarks
         * - The structure of the returned object depends on the input and may include fields such as ID, Type, Author, Images, etc.
         */
        mapPostForRender(post: any = {}) {
            const postObject =
                (get(post, 'object', post) as {
                    ID?: any;
                    Type?: string;
                    UserID?: any;
                    AuthorID?: any;
                    Author?: any;
                    Text?: string;
                    Slug?: string;
                    CreatedAt?: any;
                    Created?: any;
                    UpdatedAt?: any;
                    Updated?: any;
                    SentAnnouncement?: any;
                    Images?: any[];
                    ImageURLs?: any[];
                    SpaceID?: any;
                    ParentContent?: any;
                    Parent?: any;
                    ParentID?: any;
                    ParentType?: any;
                    FeaturedContentType?: any;
                    FeatureContentID?: any;
                    Reactions?: any;
                    Variant?: any;
                    PollQuestion?: any;
                    PollOptions?: any;
                    PollMultiSelect?: any;
                    PollExpiresAt?: any;
                    Attachments?: any;
                }) || {};
            const images = map(get(postObject, 'Images', get(postObject, 'ImageURLs', [])), (image) =>
                image?.ImageURL ? image : { ImageURL: image }
            );

            return {
                ID: postObject.ID,
                Type: 'post',
                AuthorID: postObject.UserID || postObject.AuthorID,
                Author: postObject.Author,
                Text: postObject.Text,
                Slug: postObject.Slug,
                CreatedAt: postObject.CreatedAt || postObject.Created,
                UpdatedAt: postObject.UpdatedAt || postObject.Updated,
                AnnouncedBy: get(post, 'space'),
                SentAnnouncement: postObject.SentAnnouncement,
                Images: images,
                SpaceID: postObject.SpaceID,
                Space: get(post, 'space'),
                ParentContent: postObject.ParentContent,
                Parent: postObject.Parent,
                ParentID: postObject.ParentID || this.page.ID,
                ParentType: postObject.ParentType || 2,
                FeaturedContentType: postObject.FeaturedContentType,
                FeatureContentID: postObject.FeatureContentID,
                Reactions: postObject.Reactions,
                ProjectID: this.page.ID,
                Variant: postObject.Variant,
                PollQuestion: postObject.PollQuestion,
                PollOptions: postObject.PollOptions,
                PollMultiSelect: postObject.PollMultiSelect,
                PollExpiresAt: postObject.PollExpiresAt,
                Attachments: postObject.Attachments,
            };
        },

        saveSection(section, index) {
            this.page.Sections[index] = section;
            this.sectionsRerenderKey += 1;
            this.updatePage();
        },
        deleteSection(index) {
            if (!this.page.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            this.page.Sections.splice(index, 1);
            this.sectionsRerenderKey += 1;
            this.updatePage();
        },
        moveSectionDown(index) {
            if (!this.page.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            const temp = this.page.Sections[index];
            this.page.Sections[index] = this.page.Sections[index + 1];
            this.page.Sections[index + 1] = temp;
            this.sectionsRerenderKey += 1;
            this.updatePage();
        },
        moveSectionUp(index) {
            if (!this.page.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            const temp = this.page.Sections[index];
            this.page.Sections[index] = this.page.Sections[index - 1];
            this.page.Sections[index - 1] = temp;
            this.sectionsRerenderKey += 1;
            this.updatePage();
        },
        addSection($event, index) {
            if (!Array.isArray(this.page.Sections)) {
                // Vue 2 requires $set when an empty or legacy page has no reactive Sections property.
                this.$set(this.page, 'Sections', []);
            }
            const insertIndex = typeof index === 'number' ? index + 1 : this.page.Sections.length;
            if ($event === 'text') {
                this.page.Sections.splice(insertIndex, 0, {
                    Type: 0,
                    Content: '',
                    StartEditMode: true,
                });
            } else if ($event === 'image') {
                this.page.Sections.splice(insertIndex, 0, {
                    Type: 1,
                    Images: [],
                    StartEditMode: true,
                });
            } else if ($event === 'video') {
                this.page.Sections.splice(insertIndex, 0, {
                    Type: 3,
                    Content: '',
                    StartEditMode: true,
                });
            } else if ($event === 'audio') {
                this.page.Sections.splice(insertIndex, 0, createAudioSection());
            } else if ($event === 'paywall') {
                if (this.paywallSectionIndex !== -1) {
                    return;
                }
                this.page.Sections.splice(insertIndex, 0, {
                    Type: 4,
                    Content: '',
                });
                this.updatePage();
            } else if ($event === 'code') {
                this.page.Sections.splice(insertIndex, 0, {
                    Type: 2,
                    Content: '',
                    StartEditMode: true,
                });
            }
        },
        showAllAttachments() {
            const modal = this.$refs.attachmentsModal as { show?: () => void } | undefined;
            if (modal && typeof modal.show === 'function') {
                modal.show();
            }
        },
        triggerAttachmentPicker() {
            const input = this.$refs.pageAttachmentInput as HTMLInputElement | undefined;
            if (input) {
                input.value = '';
                input.click();
            }
        },
        onAttachmentInputChange(event) {
            const files = get(event, 'target.files');
            if (!files || files.length === 0) return;
            Array.from(files).forEach((file) => {
                this.addPendingAttachment(file);
            });
        },
        addPendingAttachment(file: File) {
            if (!file) return;
            const extension = file.name.includes('.') ? file.name.split('.').pop() : '';
            const normalized = normalizeAttachmentFile({
                Name: file.name,
                file_name: file.name,
                Size: file.size,
                size: file.size,
                format: extension || file.type || '',
                Extension: extension || file.type || '',
                blob: file,
                URL: URL.createObjectURL(file),
                CreatedAt: Math.floor(Date.now() / 1000),
            });
            this.pendingPageAttachments.push({
                ...normalized,
                __tempID: `upload-${this.attachmentUploadCounter + 1}`,
            });
            this.attachmentUploadCounter += 1;
        },
        attachmentUploaded(data: any, index: number) {
            if (!data || !data.url) return;
            const pending = this.pendingPageAttachments[index];
            if (!pending) return;
            const normalized = normalizeAttachmentFile({
                ...pending,
                URL: data.url,
                url: data.url,
                Name: data.file_name || pending.Name,
                file_name: data.file_name || pending.file_name,
                Size: data.size ?? pending.Size,
                size: data.size ?? pending.size,
                format: data.format || pending.format,
                Extension: data.format || pending.Extension,
            });
            this.pendingPageAttachments.splice(index, 1);
            if (!Array.isArray(this.page.Attachments)) {
                this.$set(this.page, 'Attachments', []);
            }
            this.page.Attachments.push(normalized);
            this.updatePage();
        },
        removePendingAttachment(index: number) {
            if (index < 0 || index >= this.pendingPageAttachments.length) return;
            this.pendingPageAttachments.splice(index, 1);
        },
        removeAttachment(index: number) {
            if (!Array.isArray(this.page.Attachments)) return;
            this.page.Attachments.splice(index, 1);
            this.updatePage();

            if (!this.page.Attachments || this.page.Attachments.length === 0) {
                this.$refs.attachmentsModal.hide();
            }
        },
        removeImage() {
            this.newImage = null;
            this.page.ImageURL = [];
            this.updatePage();
        },
        headerImageInput(image) {
            if (image && image.filePreview) {
                this.newImage = image.filePreview;
                this.newImageUploading = true;
                if (!this.$store) {
                    console.error('Store not available');
                    this.newImageUploading = false;
                    return;
                }
                this.$store
                    .dispatch('imageUpload', {
                        file: image.file,
                        url: '/upload/image/pages',
                    })
                    .then((response) => {
                        this.page.ImageURL = [response];
                        this.updatePage();
                    })
                    .catch((error) => {
                        console.log(error);
                        const errorMsg = {
                            Message: this.$t('messages.imageUploadError'),
                            Details: '',
                        };
                        if (
                            error.response &&
                            error.response.data &&
                            error.response.data.message === 'Request Entity Too Large'
                        ) {
                            errorMsg.Message = this.$t('messages.imageUploadSizeError');
                        }
                        EventBus.$emit('ERROR', errorMsg);
                    })
                    .finally(() => {
                        this.newImageUploading = false;
                        this.newImage = null;
                    });
            }
        },

        follow() {
            const subs = JSON.stringify({ ProjectID: this.page.ID });
            axios({
                method: 'POST',
                url: '/project/follow',
                data: subs,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    // add me to members list
                    if (!this.page.FollowedBy) {
                        this.page.FollowedBy = [];
                    }
                    this.page.FollowedBy.push(this.$store.state.me.ID);

                    this.members.push({
                        ID: this.$store.state.me.ID,
                        Name: this.$store.state.me.Profile.Name,
                        Slug: this.$store.state.me.Slug,
                        ImageURL: get(this.$store.state.me, 'Profile.ImageURL', ''),
                        Role: 'Follower',
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        leave() {
            axios({
                method: 'POST',
                url: `/page/leave/${this.page.ID}`,
            })
                .then((response) => {
                    // remove me from members list
                    this.members = this.members.filter((item) => item.ID !== this.$store.state.me.ID);
                    this.page.FollowedBy = this.page.FollowedBy.filter((item) => item !== this.$store.state.me.ID);
                    this.joinStatus = null;
                    this.page.Contributor = this.page.Contributor.filter((item) => item !== this.$store.state.me.ID);
                    this.page.Owner = this.page.Owner.filter((item) => item !== this.$store.state.me.ID);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        unfollow() {
            const subs = JSON.stringify({ ProjectID: this.page.ID });
            axios({
                method: 'DELETE',
                url: '/project/follow',
                data: subs,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    // remove me from members list
                    this.members = this.members.filter((item) => item.ID !== this.$store.state.me.ID);
                    this.page.FollowedBy = this.page.FollowedBy.filter((item) => item !== this.$store.state.me.ID);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getPage() {
            this.loading = true;
            this.resetFeedState();
            axios({
                method: 'GET',
                url: `/project/by-slug/${this.pageSlug}`,
            })
                .then((response) => {
                    if (response.data) {
                        const page = response.data;
                        page.ImageURL = get(page, 'ImageURL', []).filter(
                            (image) => !image.includes('/img/Platform_Gradient')
                        );
                        this.page = page;

                        if (get(this.page, 'Sections', []).length === 0 && this.page.Description) {
                            this.page.Sections = [
                                {
                                    Type: 0,
                                    Content: this.page.Description,
                                },
                            ];
                        }

                        if (this.page.JoinStrategy === 1) {
                            this.inviteOnly = false;
                            this.approvalBased = true;
                            this.open = false;
                        } else if (this.page.JoinStrategy === 2) {
                            this.inviteOnly = false;
                            this.approvalBased = false;
                            this.open = true;
                        } else {
                            this.inviteOnly = true;
                            this.approvalBased = false;
                            this.open = false;
                        }

                        if (this.visibilityStatus === PAGE_VISIBILITY.PAID) {
                            this.availablePlanIds = this.page.AvailablePlans || this.page.AvailableInPlans || [];
                            this.syncSelectedPlans();
                        } else {
                            this.availablePlanIds = [];
                            this.selectedPlans = [];
                        }

                        if (!this.shouldShowFeedPreview) {
                            this.getPageFeed();
                        }
                        this.getJoinSatatus();
                        this.getPendingRequests();
                        this.getAllPlans();

                        window.setTimeout(() => {
                            this.triggerQueryConfettie();
                        }, 800);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if (error.message.includes('404')) {
                        this.$router.push('/not-found/page').catch(() => {});
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getPageChannel() {
            axios
                .get('/project/channel/list')
                .then((response) => {
                    if (response.data) {
                        const channelList = response.data.objects.map((channel) => channel.object);

                        this.channelList = channelList;

                        if (!channelList || channelList.length === 0) {
                            return;
                        }

                        const channel = channelList.find((c) => c.ID === this.page.ChannelID);
                        if (channel && channel.Slug) {
                            this.channel = channel;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getPageContributores() {
            this.loading = true;

            if (!this.page.Contributor || !this.page.Contributor.length) {
                this.loading = false;
                return;
            }

            // map list of contributor ids from page.Contributor to {IDS: [{ID: 1}, {ID: 2}]} to send as payload
            const ids = this.page.Contributor.map((id) => ({ ID: id }));
            if (!ids.length) {
                this.loading = false;
                return;
            }

            const requestBody = { IDS: ids };
            axios({
                method: 'POST',
                url: `/user/listbyids`,
                data: requestBody,
            })
                .then((response) => {
                    if (response.data && response.data.Users) {
                        // map response data to User object
                        this.contributors = response.data.Users.map((item) => ({
                            ID: item.ID,
                            Name: get(item, 'Profile.Name', ''),
                            Slug: item.Slug,
                            ImageURL: get(item, 'Profile.ImageURL', ''),
                            Role: 'Contributor',
                            Score: get(item, 'Score', 0),
                        }));

                        // add contributors to members list
                        this.members = this.members.concat(this.contributors);
                        this.sortMembers();
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getPageOwners() {
            this.loading = true;

            if (!this.page.Owner || !this.page.Owner.length) {
                this.loading = false;
                return;
            }

            // map list of owner ids from page.Owner to {IDS: [{ID: 1}, {ID: 2}]} to send as payload
            const ids = this.page.Owner.map((id) => ({ ID: id }));
            if (!ids.length) {
                this.loading = false;
                return;
            }

            const requestBody = { IDS: ids };
            axios({
                method: 'POST',
                url: `/user/listbyids`,
                data: requestBody,
            })
                .then((response) => {
                    if (response.data && response.data.Users) {
                        this.owners = response.data.Users.map((item) => ({
                            ID: item.ID,
                            Name: get(item, 'Profile.Name', ''),
                            Slug: item.Slug,
                            ImageURL: get(item, 'Profile.ImageURL', ''),
                            Role: 'Owner',
                            Score: get(item, 'Score', 0),
                        }));

                        // add owners to members list
                        this.members = this.members.concat(this.owners);
                        this.sortMembers();
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getPageFollowers() {
            this.loading = true;

            if (!this.page.FollowedBy || !this.page.FollowedBy.length) {
                this.loading = false;
                return;
            }

            // map list of follower ids from page.FollowedBy to {IDS: [{ID: 1}, {ID: 2}]} to send as payload
            const ids = this.page.FollowedBy.map((id) => ({ ID: id }));
            if (!ids.length) {
                this.loading = false;
                return;
            }

            const requestBody = { IDS: ids };
            axios({
                method: 'POST',
                url: `/user/listbyids`,
                data: requestBody,
            })
                .then((response) => {
                    if (response.data && response.data.Users) {
                        // map response data to User object
                        this.followers = response.data.Users.map((item) => ({
                            ID: item.ID,
                            Name: get(item, 'Profile.Name', ''),
                            Slug: item.Slug,
                            ImageURL: get(item, 'Profile.ImageURL', ''),
                            Role: 'Follower',
                            Score: get(item, 'Score', 0),
                        }));

                        // add followers to members list
                        this.members = this.members.concat(this.followers);
                        this.sortMembers();
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /**
         * Fetches the feed (updates) for the current page.
         *
         * Side effects:
         * - Modifies `this.updates` with the fetched updates.
         * - Sets `this.loadingUpdates` to indicate loading state.
         *
         * Error handling:
         * - Logs any errors to the console.
         * - Ensures `this.loadingUpdates` is reset to false in all cases.
         */
        async getPageFeed() {
            if (this.shouldShowFeedPreview || !this.page?.ID) {
                this.loadingUpdates = false;
                return;
            }

            this.loadingUpdates = true;
            let url = `/page/feed/${this.page.ID}`;
            if (this.updatesNextPage) {
                url = this.updatesNextPage;
            }

            try {
                const response = await axios({
                    method: 'GET',
                    url,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                let feedObjects =
                    get(response, 'data.objects', null) || (Array.isArray(response?.data) ? response.data : null) || [];

                this.updatesNextPage = get(response, 'data.next', null);

                if (!Array.isArray(feedObjects)) {
                    feedObjects = [];
                }

                let feedEntries = feedObjects.map((entry) => (get(entry, 'object') ? entry : { object: entry }));

                const fetchUsers = uniq(
                    feedEntries
                        .map(
                            (update) =>
                                get(update, 'object.AuthorID') ||
                                get(update, 'object.UserID') ||
                                get(update, 'object.CreatedBy')
                        )
                        .filter(Boolean)
                );

                let users = [];
                if (fetchUsers.length > 0) {
                    try {
                        const usersResponse = await axios({
                            method: 'POST',
                            url: '/user/listbyids',
                            data: { IDS: map(fetchUsers, (id) => ({ ID: id })) },
                            withCredentials: true,
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });

                        users = map(get(usersResponse, 'data.Users', []), (user) => ({
                            ID: get(user, 'ID'),
                            Name: get(user, 'Profile.Name'),
                            Slug: get(user, 'Slug'),
                            ImageURL: get(user, 'Profile.ImageURL'),
                            Bio: get(user, 'Profile.Bio'),
                        }));
                    } catch (error) {
                        console.log(error);
                    }
                }

                feedEntries = feedEntries.map((update) => {
                    if (!update.object) return update;

                    const authorId =
                        get(update, 'object.AuthorID') ||
                        get(update, 'object.UserID') ||
                        get(update, 'object.CreatedBy');

                    if (!update.object.Author && users && users.length) {
                        update.object.Author = users.find((user) => user.ID === authorId);
                    }

                    update.object.CreatedAt = update.object.CreatedAt || update.object.Created;
                    const images = get(update, 'object.Images', get(update, 'object.ImageURLs', []));
                    update.object.Images = map(images, (i) => (i?.ImageURL ? i : { ImageURL: i }));
                    if (!update.object.ParentID) {
                        update.object.ParentID = this.page.ID;
                    }
                    if (!update.object.ParentType) {
                        update.object.ParentType = 2;
                    }

                    return update;
                });

                this.updatesBank = this.updatesBank.concat(feedEntries);
                this.updatesBank.sort(
                    (a, b) =>
                        (Number(get(b, 'object.CreatedAt', get(b, 'object.Created', 0))) || 0) -
                        (Number(get(a, 'object.CreatedAt', get(a, 'object.Created', 0))) || 0)
                );

                this.updatesBank = this.updatesBank.filter(
                    (thing, index, self) =>
                        index === self.findIndex((t) => get(t, 'object.ID') === get(thing, 'object.ID'))
                );

                // initially load first 3 updates
                if (this.updates.length === 0 && this.updatesBank.length > 0) {
                    if (this.updatesBank.length > 3) {
                        // this.updates.push(...this.updatesBank.slice(0, 3));
                        this.updates = this.updates.concat(this.updatesBank.slice(0, 3));
                        this.updatesBank = this.updatesBank.slice(3);
                    } else {
                        // this.updates.push(...this.updatesBank);
                        this.updates = this.updates.concat(this.updatesBank);
                        this.updatesBank = [];
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingUpdates = false;
            }
        },
        postDeleted(postID) {
            this.updates = this.updates.filter((post) => get(post, 'object.ID') !== postID);
            this.updatesBank = this.updatesBank.filter((post) => get(post, 'object.ID') !== postID);
            this.removePendingStreamPostID(postID);
        },

        scroll() {
            window.onscroll = () => {
                if (this.shouldShowFeedPreview) {
                    return;
                }

                const feedContainer = this.$refs['feed-container'];
                if (!feedContainer) return;

                // get the distance from the bottom of the page to the bottom of the feed container
                const distanceFromBottom = feedContainer.getBoundingClientRect().bottom - window.innerHeight;

                const percentage = (distanceFromBottom * 100) / feedContainer.clientHeight;

                if (percentage < 10) {
                    if (this.updatesBank.length !== 0 && this.updatesBank.length > 3) {
                        // this.updates.push(...this.updatesBank.slice(0, 3));
                        this.updates = this.updates.concat(this.updatesBank.slice(0, 3));
                        this.updatesBank = this.updatesBank.slice(3);
                    } else if (this.updatesBank.length !== 0 && this.updatesBank.length <= 3) {
                        // this.updates.push(...this.updatesBank);
                        this.updates = this.updates.concat(this.updatesBank);
                        this.updatesBank = [];
                    } else if (this.updatesNextPage && !this.loadingUpdates) {
                        this.getPageFeed();
                    }
                }
            };
        },
        discardPageChanges() {
            this.preview = false;
            this.getPage();
        },
        syncSelectedPlans() {
            if (!this.availablePlanIds.length || !this.planOptions.length) {
                this.selectedPlans = [];
                return;
            }

            // Map saved plan IDs to the option objects expected by CoMultiSelect.
            const selectedPlanIds = new Set(this.availablePlanIds.map((planId) => String(planId)));
            this.selectedPlans = this.planOptions.filter((option) => selectedPlanIds.has(String(option.Value)));
        },
        updatePage() {
            this.ensurePaywallSectionExists();

            // combine all sections into description field for backward compatibility
            this.page.Description = '';
            if (this.page.Sections && this.page.Sections.length > 0) {
                this.page.Sections.forEach((section) => {
                    if (section.Type === 4) {
                        return;
                    }

                    // if image section then add images as html img tags
                    if (section.Type === 1 && section.Images && section.Images.length > 0) {
                        section.Images.forEach((img) => {
                            this.page.Description += `<img style="width: 100%;" src="${img}" alt="event image" />\n<br>`;
                        });
                    } else {
                        this.page.Description += section.Content;
                        this.page.Description += '\n<br>';
                    }
                });
            } else {
                this.page.Description = '';
            }

            const visibilityStatus = this.getPageVisibilityStatus();
            this.setPageVisibilityStatus(visibilityStatus);
            this.page.AvailableInPlans =
                visibilityStatus === PAGE_VISIBILITY.PAID ? this.selectedPlans.map((option) => option.Value) : [];

            const update = JSON.stringify(this.page);
            this.loading = true;
            this.$store
                .dispatch('updateProject', update)
                .then((response) => {
                    this.loading = false;
                    if (this.toToogleShareInFeed) {
                        this.toToogleShareInFeed = false;
                        this.setPrefilledContentForSharingInFeed();
                    }
                    const message = {
                        Message: this.$t('labels.changessaved'),
                        Details: null,
                    };
                    EventBus.$emit('INFO', message);
                    this.$emit('saved');
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.response.data && error.response.data.message) {
                        EventBus.$emit('ERROR', {
                            Message: error.response.data.message,
                            Details: error.response.data.details,
                        });
                    } else {
                        EventBus.$emit('ERROR', {
                            Message: this.$t('labels.failedGeneric'),
                            Details: null,
                        });
                    }
                });
        },

        deletePage() {
            this.loading = true;
            const req = JSON.stringify({
                ProjectID: this.page.ID,
                UserID: this.$store.state.me.ID,
            });

            const funcName = this.amIAdmin ? 'deleteProjectAdmin' : 'deleteProject';

            this.$store
                .dispatch(funcName, req)
                .then((response) => {
                    this.$router.push('/profile/my-pages');
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.response.data && error.response.data.message) {
                        EventBus.$emit('ERROR', {
                            Message: error.response.data.message,
                            Details: error.response.data.details,
                        });
                    } else {
                        EventBus.$emit('ERROR', {
                            Message: this.$t('labels.failedGeneric'),
                            Details: null,
                        });
                    }
                });
        },

        getAllPlans() {
            if (!this.amIAdmin) {
                return;
            }
            axios({
                method: 'GET',
                url: '/admin/plan/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const planList = response?.data?.Plans || [];
                    // Normalize plans for CoUserFilter so plan chips and plan filters share the same option shape.
                    this.planOptions = planList
                        .filter((plan) => plan?.ID && plan?.Name)
                        .map((plan) => ({
                            Name: plan.Name,
                            Value: plan.ID,
                        }));
                })
                .catch((error) => {
                    console.error('Error fetching plans:', error);
                });
        },
    },
};
